import styled from 'styled-components';

export const BannerWithTextContainer = styled.section`
  padding: 122px 0 0;

  @media (max-width: 720px) {
    padding: 0;
  }
`;

export const ReadyToChoiceContainer = styled.div`
  position: relative;
  padding-top: 40%;
  width: 70%;
  margin: auto;
  cursor: pointer;
  .anchor {
    display: block;
    position: relative;
    visibility: hidden;
    top: 220px;
  }
  @media (max-width: 720px) {
    padding-top: 85%;
    width: 100%;
    cursor: default;
  }
  .carousel-desktop {
    @media (max-width: 720px) {
      display: none !important;
    }
  }
  .carousel-mobile {
    display: none !important;
    @media (max-width: 720px) {
      display: block !important;
    }
  }
`;

export const GotoTop = styled.button`
  font-family: 'Montserrat';
  background: #ef4e5e;
  color: #fff;
  font-size: clamp(12px, 2vw, 15px);
  font-weight: 500;
  border: none;
  outline: none;
  border-radius: 20vmax;
  position: fixed;
  z-index: 99;
  bottom: 140px;
  right: 100px;
  padding: 6px 12px;
  overflow: hidden;
  cursor: pointer;
  align-items: center;

  @media (max-width: 720px) {
    cursor: default;
    right: 20px;
    padding: 5px 10px;
    bottom: 120px;
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  &.goTopHidden {
    display: none;
  }

  &.goTopShow {
    display: flex;
  }
`;

export const SelectFavDiaper = styled.div`
  text-align: center;

  button {
    font-family: 'Montserrat';
    font-weight: 500;
    text-transform: uppercase;
    color: #fff;
    font-size: clamp(14px, 2vw, 20px);
    text-align: center;
    background-color: #ef4e5e;
    margin: auto;
    border: none;
    border-radius: 14vmax;
    outline: none;
    width: 84%;
    box-shadow: 1px 1px 2px 1px #0000002e;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 60px;
    line-height: 60px;

    span.ripple {
      position: absolute;
      border-radius: 50%;
      transform: scale(0);
      animation: rippleB 600ms linear;
      background-color: rgba(255, 255, 255, 0.7);
    }

    @keyframes rippleB {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }

    @media (max-width: 720px) {
      cursor: default;
      height: 40px;
      line-height: 40px;
    }
  }
`;

export const BannerImageSection = styled.div`
  position: relative;
  padding-top: ${(props) => (props.diapernewVersion ? '24%' : '20%')};

  @media (max-width: 720px) {
    padding-top: 46.75%;
  }
  .carousel-desktop {
    @media (max-width: 720px) {
      display: none !important;
    }
  }
  .carousel-mobile {
    display: none !important;
    @media (max-width: 720px) {
      display: block !important;
    }
  }
`;

export const HeadingContainer = styled.div`
  position: absolute;
  top: 46%;
  left: 40%;
  @media (max-width: 720px) {
    left: 10px;
    width: 60%;
  }
`;

export const HeadingContainerNew = styled.div`
  position: absolute;
  top: 26%;
  left: 40%;
  text-align: center;
  @media (max-width: 720px) {
    left: 2%;
    width: 60%;
    top: 31%;
    text-align: left;
  }
`;

export const BannerNewFirstHeading = styled.h1`
  display: block;
  color: hsl(0deg, 0%, 0%, 78%);
  font-size: clamp(21px, 4vw, 40px);
  padding-bottom: 7px;
  letter-spacing: 2px;

  @media (max-width: 720px) {
    letter-spacing: 0.6px;
  }
`;

export const BannerNewSecondHeading = styled.h2`
  font-size: 3.5em;
  color: hsl(0deg, 0%, 0%, 78%);
  letter-spacing: 1px;

  @media (max-width: 720px) {
    letter-spacing: 0.4px;
    font-size: 1.5em;
  }

  span {
    color: #21aa9d;
  }
`;

export const BannerHeading = styled.h1`
  font-size: calc(0.415em + 3vw);
  color: #484764;
  letter-spacing: 1px;

  @media (max-width: 720px) {
    letter-spacing: 0.4px;
  }
`;

export const BannerFirstHeading = styled.h2`
  display: block;
  color: #484764;
  font-size: ${(props) => props.fontSize};
  padding-bottom: 7px;
  letter-spacing: 0.6px;

  @media (max-width: 720px) {
    letter-spacing: 0px;
  }
`;
